import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Buyers',
    path: '/buyers'
  }, {
    name: 'Communities',
    path: '/communities'
  }, {
    name: 'Sellers',
    path: '/sellers'
  }, {
    name: 'The Collective',
    path: '/collective'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  const isHome = location.pathname === '/';
  const navBg = isScrolled || !isHome ? 'bg-sand shadow-sm' : 'bg-transparent';
  const textColor = isScrolled || !isHome ? 'text-navy' : 'text-white';
  return <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${navBg}`} data-id="element-134">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <div className="flex justify-between items-center h-24" data-id="element-136">
          <Link to="/" className={`font-serif text-2xl tracking-wider uppercase ${textColor}`} data-id="element-137">
            Cabo Collection
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex space-x-8 items-center" data-id="element-138">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm tracking-wide uppercase transition-colors hover:text-gold ${textColor} ${location.pathname === link.path ? 'font-semibold' : ''}`} data-id="element-139">
                {link.name}
              </Link>)}
          </nav>

          {/* Mobile Menu Button */}
          <button className={`md:hidden p-2 ${textColor}`} onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-140">
            {mobileMenuOpen ? <X size={24} data-id="element-141" /> : <Menu size={24} data-id="element-142" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-143">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-sand border-t border-navy/10 overflow-hidden" data-id="element-144">
            <div className="px-4 pt-2 pb-6 space-y-1 flex flex-col" data-id="element-145">
              {navLinks.map(link => <Link key={link.name} to={link.path} className="block px-3 py-4 text-navy text-lg font-serif border-b border-navy/5" data-id="element-146">
                  {link.name}
                </Link>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}